import React, { Component } from 'react'
import { connect } from 'react-redux'

import { fetchWithRetry } from '../../authorisation'
import poll from './polling'
import SyncButtonView from './views'

export class SyncButton extends Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSuccess = this.onSuccess.bind(this)
    this.pollingID = undefined

    this.state = {
      loading: false,
      last_synced_at: props.lastSyncedAt,
      currentStep: 0
    }
  }

  componentWillUnmount() {
    clearTimeout(this.pollingID)
  }

  render() {
    const {
      compact,
      right,
      children
    } = this.props

    const {
      last_synced_at,
      loading,
    } = this.state

    return (
      <SyncButtonView
        lastSyncedAt={last_synced_at}
        loading={loading}
        handleSubmit={this.handleSubmit}
        loadingText={this.currentStep().text || 'Updating records'}
        compact={compact}
        right={right}
      >
        {children}
      </SyncButtonView>
    )
  }

  handleSubmit() {
    this.setState({
      currentStep: 0,
      loading: true
    }, this.callEndpoint)
  }

  callEndpoint() {
    fetchWithRetry(
      process.env.REACT_APP_API_HOST + this.currentStep().syncPath,
      {
        token: this.props.jwt,
        method: 'POST',
        jsonAPI: true
      }, this.props.dispatchAction)
      .then(
        response => (
          response.json()
            .then(
              payload => (
                response.ok ?
                  this.onSuccess(payload) :
                  this.onFailure(payload)
              )
            )
        )
      )
      .catch(response => {
        this.onFailure(response)
      })
  }

  onSuccess(payload) {
    payload.pending ?
      this.callAgain(payload) :

      payload.data ?
        this.onSyncComplete(payload.data) :
        this.onFailure()
  }

  callAgain(payload) {
    this.pollingID = poll({
      status_path: payload.pending.status_path,
      jwt: this.props.jwt
    }, this.onSuccess)(this.props.dispatchAction)
  }

  onFailure() {
    this.setState({
      loading: false,
      currentStep: 0
    })
  }

  onSyncComplete(payload) {
    this.setState({
      currentStep: 1 + this.state.currentStep
    }, this.nextStep(payload))
  }

  nextStep(payload) {
    const {
      steps,
      onComplete
    } = this.props

    steps[this.state.currentStep] ?
      this.callEndpoint() :
      this.setState({
        last_synced_at: payload.last_synced_at || new Date().toISOString(),
        loading: false
      }, onComplete())
  }

  currentStep() {
    const {
      steps = []
    } = this.props

    return steps[this.state.currentStep] || {}
  }
}

const mapStateToProps = (state) => ({
  jwt: state.authorisation.jwt
})

const mapDispatchToProps = (dispatch) => ({
  dispatchAction: (action) => dispatch(action)
})


export default connect(mapStateToProps, mapDispatchToProps)(SyncButton)


// WEBPACK FOOTER //
// ./src/ui/sync-button/container.js